module.exports = __webpack_public_path__ + "assets/images/MXD-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/MXD-route-sheet.png
// module id = 1420
// module chunks = 1